import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import classes from '../../../commonStyles/tables.module.css';

const FinancialRequestsTableRow = ({ row }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USE EFFECTS
    useEffect(() => {
        if (isPTRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    // RENDER
    return (
        <TableRow hover className={classes.basicRowStripes}>
            <TableCell className={classes.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell>{row.participantName}</TableCell>
            <TableCell>{row.adviserName}</TableCell>
            <TableCell>{row.requestedByName}</TableCell>
            <TableCell>{row.teamName}</TableCell>
            <TableCell>{row.amount}</TableCell>
            <TableCell>{row.status}</TableCell>
            <TableCell>
                {row.dateIssued !== '1960-01-01' ? reverseFormatDate(row.dateIssued) : ''}
            </TableCell>
            <TableCell>{row.dateRequested ? reverseFormatDate(row.dateRequested) : ''}</TableCell>
            <TableCell>{row.paymentMethodType}</TableCell>
            <TableCell>{row.authorisedByName}</TableCell>
            <TableCell>{row.requestType}</TableCell>
            <TableCell>{row.paymentReason}</TableCell>
            <TableCell>{row.evidenceDocument}</TableCell>
        </TableRow>
    );
};

FinancialRequestsTableRow.propTypes = {
    row: PropTypes.object.isRequired
};

export default FinancialRequestsTableRow;
